import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../Custom-css.css';
import {Form, Container, Button} from 'react-bootstrap'

import InputGroup from 'react-bootstrap/InputGroup'
import history from './../history';
import { IoArrowBack, IoQrCodeOutline } from "react-icons/io5";
import {ucWords} from './../custom-func'
import { RiSearchEyeLine } from "react-icons/ri";
import { CircularProgressbar } from 'react-circular-progressbar';
import Swal from 'sweetalert2'

const swalBirubi = Swal.mixin({
    customClass: {
        header: 'p-0 m-0',
        confirmButton: 'btn btn-birubi-outline btn-sm color-birubi',
        cancelButton: 'btn btn-outline-dark btn-sm ml-2'
    },
    buttonsStyling: false
})


const {
    REACT_APP_API_URL,
} = process.env;

const LIST_PRODUKSI_STATE_PREFIX = 'birubi:list-produksi:state:';
const LIST_PRODUKSI_RESTORE_PREFIX = 'birubi:list-produksi:restore:';
const LIST_PRODUKSI_STATE_MAX_AGE = 30 * 60 * 1000;

class ListProduksi extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hidden: true,
            disabled: false,
            keywords:'',
            offset:0,
            nxt:1,
            produksi: []
        };
        this.query = new URLSearchParams(this.props.location.search);
        this.cariListProduksi = this.cariListProduksi.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.goToNext = this.goToNext.bind(this);
        this.saveListState = this.saveListState.bind(this);
        this.restoreListState = this.restoreListState.bind(this);
        this.restoreScrollPosition = this.restoreScrollPosition.bind(this);
        this.fetchListProduksiPage = this.fetchListProduksiPage.bind(this);
        this.refreshRestoredList = this.refreshRestoredList.bind(this);
        this.markListStateForRestore = this.markListStateForRestore.bind(this);
    }

    componentDidMount(){
        if(localStorage.getItem('token') === null){
            history.replace('/')
        }else{
            let ke = this.query.get('ke');  
            const level = localStorage.getItem('level');
            const role = JSON.parse(localStorage.getItem('role'));
            if(ke !== 'masuk_rak'){
                
                if(level < 3 || role.pkj !== 1 ){
                    swalBirubi.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Maaf anda tidak memiliki akses di fitur ini',
                        showCancelButton: false,
                        confirmButtonText: 'Kembali'
                      }).then((result) => {
                        history.goBack()
                      })
                }
            }else{
                if(role.ksr !== 1 ){
                    swalBirubi.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Maaf anda tidak memiliki akses di fitur ini',
                        showCancelButton: false,
                        confirmButtonText: 'Kembali'
                      }).then((result) => {
                        history.goBack()
                      })
                }
            }

            
            if(!this.restoreListState()){
                this.cariListProduksi(0)
            }
        }
    }

    getListStateKey(){
        return LIST_PRODUKSI_STATE_PREFIX+(this.props.location.search || 'default')
    }

    getListRestoreKey(){
        return LIST_PRODUKSI_RESTORE_PREFIX+(this.props.location.search || 'default')
    }

    getCurrentScrollY(){
        return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
    }

    saveListState(){
        try{
            sessionStorage.setItem(this.getListStateKey(), JSON.stringify({
                keywords: this.state.keywords,
                offset: this.state.offset,
                nxt: this.state.nxt,
                produksi: this.state.produksi,
                scrollY: this.getCurrentScrollY(),
                savedAt: Date.now()
            }))
        }catch(error){
            console.error(error)
        }
    }

    markListStateForRestore(){
        try{
            sessionStorage.setItem(this.getListRestoreKey(), '1')
        }catch(error){
            console.error(error)
        }
    }

    restoreListState(){
        try{
            const restoreKey = this.getListRestoreKey()
            const shouldRestore = sessionStorage.getItem(restoreKey) === '1'
            sessionStorage.removeItem(restoreKey)

            if(!shouldRestore){
                sessionStorage.removeItem(this.getListStateKey())
                return false
            }

            const rawState = sessionStorage.getItem(this.getListStateKey())
            if(!rawState){
                return false
            }

            const savedState = JSON.parse(rawState)
            if(!savedState || !Array.isArray(savedState.produksi)){
                return false
            }

            if(savedState.savedAt && Date.now() - savedState.savedAt > LIST_PRODUKSI_STATE_MAX_AGE){
                sessionStorage.removeItem(this.getListStateKey())
                return false
            }

            this.setState({
                keywords: savedState.keywords || '',
                offset: savedState.offset || 0,
                nxt: savedState.nxt || 0,
                produksi: savedState.produksi
            }, () => {
                this.restoreScrollPosition(savedState.scrollY)
                this.refreshRestoredList(savedState)
            })

            return true
        }catch(error){
            console.error(error)
            return false
        }
    }

    restoreScrollPosition(scrollY, attempt = 0){
        const targetScroll = Number(scrollY) || 0
        window.requestAnimationFrame(() => {
            window.scrollTo(0, targetScroll)

            if(attempt < 8 && Math.abs(this.getCurrentScrollY() - targetScroll) > 2){
                setTimeout(() => this.restoreScrollPosition(targetScroll, attempt + 1), 80)
            }
        })
    }

    fetchListProduksiPage(offset, keywords = this.state.keywords){
        return fetch(REACT_APP_API_URL+'get-list-produksi', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                kode_user: localStorage.getItem('kode_user'),
                schema: localStorage.getItem('schema'),
                keyword: keywords,
                offset: offset,
                ke: this.query.get('ke'),
                api_token: localStorage.getItem('token')
            })
        })
        .then((response) => response.json())
    }

    refreshRestoredList(savedState){
        const pageSize = 50;
        const loadedCount = Array.isArray(savedState.produksi) ? savedState.produksi.length : 0;
        const pageCount = Math.max(1, Math.ceil(loadedCount / pageSize));
        const keywords = savedState.keywords || '';
        const scrollY = savedState.scrollY;
        const requests = [];

        for(let page = 0; page < pageCount; page++){
            requests.push(this.fetchListProduksiPage(page * pageSize, keywords))
        }

        Promise.all(requests)
        .then((responses) => {
            let produksi = [];
            let nextOffset = savedState.offset || 0;
            let nxt = 0;

            responses.forEach((responseJson) => {
                if(responseJson.status === true && Array.isArray(responseJson.data)){
                    produksi = produksi.concat(responseJson.data)
                    nextOffset = responseJson.next_offset
                    nxt = responseJson.data.length > 0 ? 1 : 0
                }else{
                    nxt = 0
                }
            })

            this.setState({
                produksi: produksi,
                offset: nextOffset,
                nxt: nxt
            }, () => {
                this.saveListState()
                this.restoreScrollPosition(scrollY)
            })
        })
        .catch((error) => {
            console.error(error)
            this.restoreScrollPosition(scrollY)
        })
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
    
        this.setState({
            [name]: value
        });
    }
    
    cariListProduksi(reset){

        let offset = this.state.offset;
        if(reset === 1){
            offset = 0;
        }

        this.fetchListProduksiPage(offset)
        .then((responseJson) => {
            console.log(responseJson)
            // console.log(responseJson.data.pembayaran)
            if(responseJson.status === true){
                this.setState({
                    offset: responseJson.next_offset
                })

                var dataCust = [];
                if(reset === 0){
                    dataCust = this.state.produksi;
                }
                
                var nxt = 0;
                if(responseJson.data.length > 0){
                    nxt = 1;
                }

                const dtCust = responseJson.data;
                dtCust.forEach((val) => {
                    dataCust.push(val)
                });
                this.setState({
                    produksi: dataCust,
                    nxt: nxt
                })
                
            }else{

                this.setState({
                    produksi: [],
                    nxt: 0
                })
            }

            
        })
        .catch((error) => {
            console.error(error);
            this.setState({ loading: 0 })
        });
    }

    goToNext(kdTrx){
        // isinya sama buat customer
        this.saveListState()
        this.markListStateForRestore()
        let ke = this.query.get('ke');
        this.props.history.push('detail-produksi?ke='+ke+'&kdTrx='+kdTrx)
    }
    
    render() {  
        const lstProduksi = this.state.produksi.map((val, id) => {
            return (
                <div key={val.kode_transaksi} className="border mt-2" onClick={() => this.goToNext(val.kode_transaksi)}>
                    <div className="p-1 m-1">

                        <div className="row pt-1">
                            <div className="col-9">
                                <div className="font-weight-bold">{val.nama_pelanggan}</div>
                                <div className="font-weight-bold color-birubi">{val.nomor_nota}</div>
                                <span className={val.color}>{val.status}</span>
                            </div>
                            <div className="col-3">
                                <CircularProgressbar value={val.persen_prod} text={`${val.persen_prod}%`}/>    
                            </div>
                        </div>
                        <div className=" border-top mt-2"></div>
                        <div className="row pt-1">
                            <div className="col-6">
                                <div className="text-grey">Tanggal Terima</div>
                            </div>
                            <div className="col-6">
                                <div className="text-grey text-right">{val.tanggal_transaksi}</div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-6">
                                <div className="text-grey">Tanggal Selesai</div>
                            </div>
                            <div className="col-6">
                                <div className="text-grey text-right">{val.selesai}</div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        });

        return (
            <div>
                <div className="fixed-position bg-white">
                    <div className="header border-bottom shadow-sm">
                        <div className="row">
                            <div className="col-1" onClick={this.props.history.goBack}>
                                <h5><IoArrowBack /></h5>
                            </div>
                            <div className="col-9">
                                <h4>{ucWords(this.query.get('name'))}</h4>
                            </div>
                            {
                                this.query.get('scan') === '1' ?
                                    <div className="col-2">
                                        <h5><IoQrCodeOutline /></h5>
                                    </div>
                                : null
                            }
                        </div>
                    </div>

                    <Container>
                        <InputGroup className="mt-3 mb-3">
                            <Form.Control
                            type="text"
                            placeholder="No Transaksi / Nama Pelanggan"
                            className="br0 form-input"
                            name="keywords" 
                            value={this.state.keywords}
                            onChange={this.handleInputChange}
                            />
                            <h3 className="ic-fl-rg text-black-50" onClick={() => this.cariListProduksi(1)}>
                                <RiSearchEyeLine/>
                            </h3>
                        </InputGroup>
                    </Container>

                </div>

                <div className="pt-cust">
                    <Container>
                        {lstProduksi}
                        {
                            this.state.nxt === 1 ?
                            <Button className="btn-light w-100 mt-3 mb-3"  onClick={() => this.cariListProduksi(0)}>Lihat Data Lainnya</Button>
                            :null
                        }
                    </Container>
                </div>
            </div>
        );
    }
}



export default ListProduksi;
